import { render, staticRenderFns } from "./QualitySettings.vue?vue&type=template&id=bfcce438"
import script from "./QualitySettings.vue?vue&type=script&lang=js"
export * from "./QualitySettings.vue?vue&type=script&lang=js"
import style0 from "./QualitySettings.vue?vue&type=style&index=0&id=bfcce438&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfcce438')) {
      api.createRecord('bfcce438', component.options)
    } else {
      api.reload('bfcce438', component.options)
    }
    module.hot.accept("./QualitySettings.vue?vue&type=template&id=bfcce438", function () {
      api.rerender('bfcce438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Modal/QualitySettings.vue"
export default component.exports